module.exports = __webpack_public_path__ + "img/5.03.thmb.xs.b320c034.jpg";